(() => {
  const sectionIdFor = element => {
    const section = element?.closest('[id^="shopify-section-"]');
    return section?.id.replace(/^shopify-section-/, '') || '';
  };

  const renderSection = async (current, selector) => {
    const sectionId = sectionIdFor(current);
    if (!sectionId) return false;

    const url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('sections', sectionId);

    const response = await fetch(url, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh the cart.');

    const sections = await response.json();
    const html = sections[sectionId];
    if (!html) return false;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector(selector);
    if (!fresh) return false;

    current.innerHTML = fresh.innerHTML;
    return true;
  };

  const updateCartCount = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return;

    const cart = await response.json();
    document.querySelectorAll('xo-cart-size').forEach(count => {
      count.textContent = cart.item_count;
    });
  };

  const openDrawer = () => {
    if (window.location.pathname.endsWith('/cart')) return;
    const modal = document.querySelector('xo-modal[xo-name="cart"]');
    if (modal?.hasAttribute('xo-active')) return;
    const trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
    if (trigger) {
      if (customElements.get('xo-modal-trigger')) trigger.click();
      else customElements.whenDefined('xo-modal-trigger').then(() => trigger.click());
      return;
    }

    const fallbackTrigger = document.createElement('xo-modal-trigger');
    fallbackTrigger.setAttribute('xo-name', 'cart');
    fallbackTrigger.hidden = true;
    document.body.append(fallbackTrigger);
    customElements.whenDefined('xo-modal-trigger').then(() => {
      fallbackTrigger.click();
      fallbackTrigger.remove();
    });
  };

  const refresh = async ({ open = true } = {}) => {
    const drawer = document.querySelector('xo-cart-mini#xo-cart-mini');
    const cartPage = document.querySelector('xo-cart');
    const jobs = [updateCartCount()];

    if (drawer) jobs.push(renderSection(drawer, 'xo-cart-mini#xo-cart-mini'));
    if (cartPage) jobs.push(renderSection(cartPage, 'xo-cart'));

    await Promise.allSettled(jobs);
    if (open && drawer) openDrawer();
    document.dispatchEvent(new CustomEvent('talent:cart-refreshed'));
  };

  const handleRefresh = event => {
    refresh({ open: event.detail?.open !== false });
  };

  window.TalentCart = { refresh, open: openDrawer };
  document.addEventListener('cart:refresh', handleRefresh, true);
})();
